export const websiteDomain =
  process.env.NODE_ENV !== 'development'
    ? process.env.NEXT_PUBLIC_APP_DOMAIN
    : 'http://localhost:3000';

    export const apiDomain =
  process.env.NODE_ENV !== 'development'
    ? process.env.NEXT_PUBLIC_API_DOMAIN
    : 'http://localhost:3001';

export const appInfo = {
  appName: 'LtDan',
  websiteDomain: websiteDomain || 'http://localhost:3000',
  apiDomain: apiDomain || 'http://localhost:3001',
  apiBasePath: '/api/auth/',
  websiteBasePath: '/',
};
